import moment from 'moment';

// Badge por status, compartilhado entre o card semanal (aluno e professor) e o
// modal de detalhe do professor.
export const STATUS_META = {
  'ao-vivo': { label: 'Ao vivo', badgeVariant: 'red' },
  agendada: { label: 'Agendada', badgeVariant: 'info-soft' },
  finalizada: { label: 'Finalizada', badgeVariant: 'muted' }
};

export function getLiveClassStatus(liveClass, now = moment()) {
  const start = moment(liveClass['initial-date']);
  const end = moment(liveClass['end-date']);

  if (now.isBetween(start, end)) return 'ao-vivo';
  if (now.isBefore(start)) return 'agendada';
  return 'finalizada';
}

export function formatLiveClassTimeRange(liveClass) {
  const start = moment(liveClass['initial-date']);
  const end = moment(liveClass['end-date']);
  const isSameDay = start.isSame(end, 'day');
  return `${start.format(isSameDay ? 'H[h]mm' : 'DD/MM - H[h]mm')} às ${end.format(isSameDay ? 'H[h]mm' : 'DD/MM - H[h]mm')}`;
}
